import { Component, Input, OnInit, inject } from "@angular/core";
import { BaseDataTablePageDirective } from "@app/view/shared/base-pages/base-data-table-page/base-data-table-page.directive";
import { PlannerStore } from "@app/services/store/planner-store";
import { SystemSearchMetaRestService } from "@app/services/hal/system-search-meta-rest.service";
import { Store } from "@ngrx/store";
import { MatDialog } from "@angular/material/dialog";
import { UntypedFormBuilder } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ServiceErrorHandlerService } from "@app/view/shared/service-error-handler.service";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { Planner } from "@app/models/rest/planner";
import { PlannerTeamEditorComponent } from "@app/view/setup/resourcing/planner/planner-team-editor/planner-team-editor.component";
import { MatToolbar } from "@angular/material/toolbar";
import { MatButton } from "@angular/material/button";
import { GridComponent } from "../../../../shared/base-pages/base-data-table-page/grid.component";
import { MatPaginator } from "@angular/material/paginator";
import { TranslatePipe } from "@ngx-translate/core";
import { Model } from "@bryntum/core-thin";
import { Column } from "@bryntum/grid-thin";

@Component({
  selector: "app-planner-list",
  templateUrl: "./planner-list.component.html",
  styleUrls: ["./planner-list.component.scss"],
  imports: [MatToolbar, MatButton, GridComponent, MatPaginator, TranslatePipe]
})
export class PlannerListComponent
  extends BaseDataTablePageDirective<Planner>
  implements OnInit
{
  plannerStore: PlannerStore;
  protected store: Store<any>;
  protected dialog: MatDialog;
  protected formBuilder: UntypedFormBuilder;
  protected router = inject(Router);
  protected route = inject(ActivatedRoute);
  serverErrorHandler: ServiceErrorHandlerService;
  protected ngxUiLoaderService: NgxUiLoaderService;

  @Input()
  public columns: object[] = [
    {
      field: "displayName",
      text: "Name",
      width: 150,
      editor: false,
      sortable: true
    },
    {
      field: "userName",
      text: "Email",
      width: 300,
      editor: false,
      sortable: true
    },

    {
      id: "teams-column",
      text: "Teams",
      type: "template",
      field: "planner.team.name",
      flex: 1,
      // Sorting by a planner's teams is not supported server-side: teamList is a
      // many-to-many collection, so there is no single team name to order by.
      sortable: false,
      cellMenuItems: [
        {
          text: "Edit Team List",
          icon: "b-fa b-fa-palette",
          onItem: this.teamChooser.bind(this)
        }
      ],
      template: ({ record }) => {
        console.log("teams record", record);

        if (record.teamList.length === 0) {
          return "None";
        }
        return record.teamList.map((team) => team.name).join(", ");
      }
    }
  ];

  constructor() {
    const systemSearchMetaRestService = inject(SystemSearchMetaRestService);
    const plannerStore = inject(PlannerStore);
    const store = inject<Store<any>>(Store);
    const dialog = inject(MatDialog);
    const formBuilder = inject(UntypedFormBuilder);
    const serverErrorHandler = inject(ServiceErrorHandlerService);
    const ngxUiLoaderService = inject(NgxUiLoaderService);

    super(
      systemSearchMetaRestService,
      plannerStore,
      store,
      dialog,
      "Planner",
      formBuilder,
      serverErrorHandler,
      ngxUiLoaderService
    );
    this.plannerStore = plannerStore;
    this.store = store;
    this.dialog = dialog;
    this.formBuilder = formBuilder;
    this.serverErrorHandler = serverErrorHandler;
    this.ngxUiLoaderService = ngxUiLoaderService;

    this.teamChooser = this.teamChooser.bind(this);
    this.onCellClick = this.onCellClick.bind(this);
  }

  public get pristine() {
    return (
      !this.gridStore.changes ||
      (this.gridStore.changes.added.length === 0 &&
        this.gridStore.changes.removed.length === 0 &&
        this.gridStore.changes.modified.length === 0)
    );
  }

  onCellClick(event: { record: Model; column: Column }) {
    if (event.column.id === "teams-column") {
      this.teamChooser({ record: event.record });
    }
  }

  teamChooser(data: { record: any }) {
    console.log("item clicked", data);
    let dialogRef = this.dialog.open(PlannerTeamEditorComponent, {
      data: {
        planner: data.record.originalData
      },
      width: "350px",
      height: "400px",
      panelClass: "team-chooser-dialog"
    });
    dialogRef.afterClosed().subscribe((value) => {
      this.gridStore.load({}).then();
    });
  }

  ngOnInit() {
    super.ngOnInit();
    this.gridStore.autoCommit = false;
    this.gridStore.load({}).then();
  }
}
